<div mat-dialog-content>
  <div class="subtitle">{{ inputCompany.regularName }}</div>
  <img
    *ngIf="inputCompany.immoscoop"
    src="/assets/immoscoop_banner.png"
    class="immoscoop-logo"
  />
  <p *ngIf="!inputCompany.immoscoop">Geen lid Immoscoop</p>
  <img
    *ngIf="inputCompany.spotto"
    src="/assets/spotto_banner.png"
    class="spotto-logo"
  />
  <p *ngIf="!inputCompany.spotto">Geen lid Spotto</p>
  <div *ngIf="inputCompany.pmsColors?.length > 0" class="bottom-space">
    <span class="strong"
      >{{ inputCompany.pmsColors.length === 1 ? 'PMS kleur' : 'PMS kleuren' }}:
    </span>
    <span>{{ pmsColorDisplay }}</span>
  </div>
  <div
    *ngIf="
      inputCompany.colorsExtraInfo != null &&
      inputCompany.colorsExtraInfo.length > 0
    "
  >
    <div class="subtitle">Kleuren extra info</div>
    <p>{{ inputCompany.colorsExtraInfo }}</p>
  </div>
</div>
